// extracted by mini-css-extract-plugin
export default {"container":"LabeledValue_container__HfZLa","label":"LabeledValue_label__huqkD"};